import React from 'react';
import { Provider } from 'react-redux';
import withRedux from 'next-redux-wrapper';
import App, { Container } from 'next/app';
import Head from 'next/head';
import { UIKitContext } from 'tmt-ui-kit';
import ga from 'react-ga';
import cookie from 'cookie';
// import { loadCSS } from 'fg-loadcss';
// import Router from 'next/router';
import moment from 'moment-timezone';
import getConfig from 'next/config';

import SiteCountryContext from '~/utils/context/SiteCountryContext';
import { isAustralianSite } from '~/utils/region-site-config';
import createStore from '~/redux/createStore';
import { actions as infoActions } from '~/redux/reducers/info';
import { actions as appActions } from '~/redux/reducers/app';

import AppComponent from '~/components/App';

import config from '~/config';
// import { isMobile, getCookie } from '~/utils/helpers';

moment.tz.setDefault('Asia/Bangkok');

const enhance = withRedux(createStore);

const { publicRuntimeConfig } = getConfig();

const theme = {
  articleBorderGray: '#d8d8d8',
};

class MyApp extends App {
  static async getInitialProps({ Component, ctx }) {
    const { store, req } = ctx;
    const state = store.getState();
    if (!state.info.combinedStaticLoaded) {
      await store.dispatch(infoActions.loadCombinedStatic());
    }
    let pageProps = {};
    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }
    if (ctx.isServer) {
      const { affid: queryAffId } = ctx.query;
      const cookieAffid = cookie.parse(req.headers.cookie || '').reference_id;
      const affId = global.__PARTNER__ || queryAffId || cookieAffid;
      if (!!affId) {
        await store.dispatch(appActions.getPartnerConfig(affId));
      }
    }
    return {
      pageProps,
      query: ctx.query,
      url: { query: ctx.query, pathname: ctx.pathname },
      partnerConfig: store.getState().app.partnerConfig,
    };
  }

  componentDidMount() {
    const uniqueId = cookie.parse(window.document.cookie).unique_id;
    const analyticParams = [
      {
        trackingId: config.gaTokens.en,
        debug: false,
        gaOptions: {
          clientId: uniqueId,
          userId: null,
        }
      }
    ];
    if (isAustralianSite()) {
      analyticParams.push({
        trackingId: config.gaTokens.au,
        debug: false,
        gaOptions: {
          clientId: uniqueId,
          userId: null,
          name: 'auTracker'
        }
      });
    }
    // console.log(config.gaTokens.au, isAustralianSite(), analyticParams);
    ga.initialize(analyticParams);
    ga.plugin.require('displayfeatures', undefined, ['auTracker']);
    document.addEventListener('copy', this.handleCopyEvent, true);
  }

  componentWillUnmount() {
    document.removeEventListener('copy', this.handleCopyEvent, true);
  }

  handleCopyEvent = e => {
    e.preventDefault();
    const { pathname } = this.props.url;
    const exceptionList = ['FIRSTBOOKING'];
    const exceptionPath = ['/customize/transfer'];
    const focusText = window.getSelection().toString();
    const clipdata = e.clipboardData || window.clipboardData || e.originalEvent.clipboardData; // prettier-ignore
    if (clipdata && !exceptionList.includes(focusText) && !exceptionPath.includes(pathname)) {
      const pagelink = ' https://www.takemetour.com';
      const copytext = focusText + pagelink;
      clipdata.setData('Text', copytext);
    } else {
      clipdata.setData('Text', focusText);
    }
  };

  render() {
    const { Component, pageProps, store, url, partnerConfig } = this.props;
    const { theme: partnerTheme } = partnerConfig;
    // console.log(publicRuntimeConfig);
    return (
      <Container>
        <Head>
          <title>TakeMeTour - See Thailand through the local&apos;s eyes</title>
        </Head>
        <SiteCountryContext.Provider value={publicRuntimeConfig.country || 'EN'}>
          <Provider store={store}>
            <UIKitContext
              fixPath={config.baseURL.en}
              prefixPath={config.mediaPath}
              prefixAssetPath={config.uiKitAssetPath}
              facebookAppId={config.facebookAppId}
              googleClientId={config.googleClientId}
              customTheme={{ ...pageProps.customTheme, partner: partnerTheme, ...theme }}
            >
              <AppComponent url={url}>
                <Component {...pageProps} url={url} />
              </AppComponent>
            </UIKitContext>
          </Provider>
        </SiteCountryContext.Provider>
      </Container>
    );
  }
}

export default enhance(MyApp);
